import React, { useState } from 'react';
import { HiOutlineArrowSmRight } from "react-icons/hi";
import Modal from './modal'; // Ensure the path is correct
import ReactPlayer from 'react-player/youtube'
import VideoPlayer from './video';

const ProjectItems = ({ item }) => {
  const [showForm, setShowForm] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [questionsVisible, setQuestionsVisible] = useState(false);
  const [answers, setAnswers] = useState({});
  const [resultsVisible, setResultsVisible] = useState(false);

  const correctCode = "10002000"; // Define your correct code or password here

  const questions = [
    {
      id: 1,
      question: "سؤال 1:",
      options: ["خيار 1", "خيار 2", "خيار 3", "خيار 4"],
      correctAnswer: "خيار 1"
    },
    {
      id: 2,
      question: "سؤال 2:",
      options: ["خيار 1", "خيار 2", "خيار 3", "خيار 4"],
      correctAnswer: "خيار 2"
    },
    {
      id: 3,
      question: "سؤال 3:",
      options: ["خيار 1", "خيار 2", "خيار 3", "خيار 4"],
      correctAnswer: "خيار 3"
    },
    {
      id: 4,
      question: "سؤال 4:",
      options: ["خيار 1", "خيار 2", "خيار 3", "خيار 4"],
      correctAnswer: "خيار 4"
    },
  ];

  const handleButtonClick = (e) => {
    e.preventDefault();
    setShowForm(true);
  };

  const handleInputChange = (e) => {
    setCode(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === correctCode) {
      setIsModalOpen(true); // Open the modal
    } else {
      setError('الكود غير صحيح. يرجى المحاولة مرة أخرى.');
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setQuestionsVisible(false);
    setResultsVisible(false);
  };

  const handleAnswerChange = (questionId, answer) => {
    setAnswers(prevAnswers => ({ ...prevAnswers, [questionId]: answer }));
  };

  const toggleQuestions = () => {
    setQuestionsVisible(prevState => !prevState);
  };

  const handleSubmitAnswers = (e) => {
    e.preventDefault();
    setResultsVisible(true);
  };

  const getAnswerColor = (questionId) => {
    const question = questions.find(q => q.id === questionId);
    const userAnswer = answers[questionId];
    
    if (!userAnswer) return 'blue'; // Not answered
    return userAnswer === question.correctAnswer ? 'green' : 'red'; // Correct or incorrect
  };

  const calculateScore = () => {
    const correctAnswers = questions.filter(q => answers[q.id] === q.correctAnswer).length;
    return `${correctAnswers}/${questions.length}`;
  };

  const getOverallResultColor = (score) => {
    const [correct, total] = score.split('/').map(Number);
    if (correct === total) return 'green';
    if (correct === total - 1) return 'blue';
    return 'red';
  };

  const getEncouragingMessage = (score) => {
    const [correct, total] = score.split('/').map(Number);
    if (correct === total) return "ممتاز! لقد أجبت على جميع الأسئلة بشكل صحيح.";
    if (correct === total - 1) return "جيد جداً! لقد أجبت على معظم الأسئلة بشكل صحيح.";
    return "لا بأس، حاول مرة أخرى لتحسين أدائك.";
  };

  return (
    <div className="project__card" key={item.id}>
      <img className="project__img" src={item.image} alt={item.title} />
      <h3 className="project__title">{item.title}</h3>
      {!showForm ? (
        <a href="#" className="project__button" onClick={handleButtonClick}>
          إشتراك الآن <HiOutlineArrowSmRight className="project__button-icon" />
        </a>
      ) : (
        <form onSubmit={handleSubmit} className="project__form">
          <input
            type="text"
            placeholder="أدخل الكود هنا"
            value={code}
            onChange={handleInputChange}
            className="project__input"
            required
          />
          <button type="submit" className="project__submit-button">
            تحقق
          </button>
          {error && <p className="project__error">{error}</p>}
        </form>
      )}

      {/* Modal for video and questions */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="modal-content">
          <h1>قائمة التشغيل</h1>
          <VideoPlayer/>


          <button className="questions-toggle" onClick={toggleQuestions}>
            {questionsVisible ? "إخفاء الأسئلة" : "عرض الأسئلة"}
          </button>
          {questionsVisible && (
            <>
              <form onSubmit={handleSubmitAnswers}>
                <div className="questions">
                  {questions.map(question => (
                    <div className="question-item" key={question.id}>
                      <h3>{question.question}</h3>
                      <div className="options">
                        {question.options.map(option => (
                          <label key={option}>
                            <input
                              type="radio"
                              name={`question-${question.id}`}
                              value={option}
                              checked={answers[question.id] === option}
                              onChange={() => handleAnswerChange(question.id, option)}
                            />
                            {option}
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
                <button type="submit" className="submit-answers-button">
                  إرسال الإجابات
                </button>
              </form>
              {resultsVisible && (
                <div className="results" style={{ color: getOverallResultColor(calculateScore()) }}>
                  <h2>النتائج</h2>
                  {questions.map(question => (
                    <div className="result-item" key={question.id} style={{ color: getAnswerColor(question.id) }}>
                      <h3>{question.question}</h3>
                      <p>
                        الإجابة الصحيحة: <strong>{question.correctAnswer}</strong>
                      </p>
                      <p>
                        إجابتك: <strong>{answers[question.id] || "لم يتم الإجابة"}</strong>
                      </p>
                    </div>
                  ))}
                  <h3>نتيجتك: {calculateScore()}</h3>
                  <p>{getEncouragingMessage(calculateScore())}</p>
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ProjectItems;
